export default {"src":"/_next/static/media/ra-outline-jet-one-suites.534a5b12.svg","height":52,"width":52,"blurWidth":0,"blurHeight":0};